import { axiosSwagger } from "@/axios";



export const state = {
  // my folder
  myFolder: {
    loading: false,
    data: [],
  }
}


export const getters = {
}


export const mutations = {
  // MY FOLDER
  myFolderLoading: (state, loading) => {
    state.myFolder.loading = loading;
  },
  setMyFolderData: (state, data) => {
    state.myFolder.data = modifyData( data );
  },
  setMyFolderDataV2: (state, data) => {
    state.myFolder.data = data;
  },
}


export const actions = {
  // MY FOLDER
  async readMyFolder({ commit }, parentId) {
    commit("myFolderLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileFolder/Simple/My/${parentId}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("setMyFolderData", response.data);
        commit("myFolderLoading", false);

        return response;
      })
      .catch(() => {
        commit("myFolderLoading", false);
      });
  },
  async readMyFolderV2({ commit }, id) {
    commit("myFolderLoading", true);

    if(id && id !== null){
      return await axiosSwagger
        .get(`/api/FileFolder/Child/${id}`)
        .then((response) => {
          commit("setMyFolderDataV2", response.data);
          commit("myFolderLoading", false);

          return response;
        })
        .catch(() => {
          commit("myFolderLoading", false);
        });
    }
    else{
      return await axiosSwagger
        .get("/api/FileFolder/My")
        .then((response) => {
          commit("setMyFolderDataV2", response.data);
          commit("myFolderLoading", false);

          return response;
        })
        .catch(() => {
          commit("myFolderLoading", false);
        });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async readMyFolderByParentId({ commit }, id) {
    return await axiosSwagger
      .get(`/api/FileFolder/GetFileFolderById/${id}`)
      .then((response) => {
        return response;
      });
  }
}



const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.childFolders = [];
    });

    return arrayData;
  }

  return [];
};